import {
	coverageFeedSourceList,
	coverageFeedSourceCreate,
	coverageFeedSourceUpdate,
	coverageFeedSourceDestroy,
	coverageFeedSourceTest,
	coverageFeedSourceSyncDirectory,
} from '@/services/agency/coverageFeedSources.service'

export default {
	namespaced: true,
	state: {
		list: { data: [], meta: { pagination: { total: 0 } } },
		listStatus: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
		testStatus: 'init',
		syncStatus: 'init',
	},
	getters: {
		getList(state) { return state.list },
		getListStatus(state) { return state.listStatus },
		getSaveStatus(state) { return state.saveStatus },
		getDeleteStatus(state) { return state.deleteStatus },
		getTestStatus(state) { return state.testStatus },
		getSyncStatus(state) { return state.syncStatus },
	},
	mutations: {
		SET_LIST(state, value) { state.list = value },
		LIST_STATUS(state, value) { state.listStatus = value },
		SAVE_STATUS(state, value) { state.saveStatus = value },
		DELETE_STATUS(state, value) { state.deleteStatus = value },
		TEST_STATUS(state, value) { state.testStatus = value },
		SYNC_STATUS(state, value) { state.syncStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('LIST_STATUS', 'pending')
			try {
				const { data } = await coverageFeedSourceList(params)
				commit('SET_LIST', data)
				commit('LIST_STATUS', 'init')
				return data
			} catch (error) {
				commit('LIST_STATUS', 'init')
				throw error
			}
		},
		async save({ commit }, params) {
			commit('SAVE_STATUS', 'pending')
			try {
				const { data } = await coverageFeedSourceCreate(params)
				commit('SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SAVE_STATUS', 'init')
				throw error
			}
		},
		// Background-friendly update (status switch): does not flip the modal's save spinner.
		async update({ commit }, params) {
			commit('SAVE_STATUS', 'pending')
			try {
				const { data } = await coverageFeedSourceUpdate(params)
				commit('SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SAVE_STATUS', 'init')
				throw error
			}
		},
		async toggle(context, params) {
			const { data } = await coverageFeedSourceUpdate(params)
			return data
		},
		async delete({ commit }, params) {
			commit('DELETE_STATUS', 'pending')
			try {
				const { data } = await coverageFeedSourceDestroy(params)
				commit('DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('DELETE_STATUS', 'init')
				throw error
			}
		},
		async test({ commit }, params) {
			commit('TEST_STATUS', 'pending')
			try {
				const { data } = await coverageFeedSourceTest(params)
				commit('TEST_STATUS', 'init')
				return data
			} catch (error) {
				commit('TEST_STATUS', 'init')
				throw error
			}
		},
		async syncDirectory({ commit }) {
			commit('SYNC_STATUS', 'pending')
			try {
				const { data } = await coverageFeedSourceSyncDirectory()
				commit('SYNC_STATUS', 'init')
				return data
			} catch (error) {
				commit('SYNC_STATUS', 'init')
				throw error
			}
		},
	},
}
